import Image from 'next/image';
import type { ReactElement } from 'react';
export interface BankLogo {
  name: string;
  icon: ReactElement;
  cardNo: string;
  code: string;
}
export const bankLogoList: BankLogo[] = [{
  name: 'بانک شهر',
  icon: <Image alt='بانک شهر' height={24} src='/images/bank/Shahr.svg' width={24} />,
  cardNo: '502806',
  code: 'CIYBIR'
}, {
  name: 'بانک شهر',
  icon: <Image alt='بانک شهر' height={24} src='/images/bank/Shahr.svg' width={24} />,
  cardNo: '504706',
  code: 'CIYBIR'
}, {
  name: 'بانک ملی ایران',
  icon: <Image alt='بانک ملی ایران' height={24} src='/images/bank/Melli.svg' width={24} />,
  cardNo: '603799',
  code: 'MELIIR'
}, {
  name: 'بانک ملی ایران',
  icon: <Image alt='بانک ملی ایران' height={24} src='/images/bank/Melli.svg' width={24} />,
  cardNo: '170019',
  code: 'MELIIR'
}, {
  name: 'بانک اقتصاد نوین',
  icon: <Image alt='بانک اقتصاد نوین' height={24} src='/images/bank/EghtesatNovin.svg' width={24} />,
  cardNo: '627412',
  code: 'BEGNIR'
}, {
  name: 'بانک ملت',
  icon: <Image alt='بانک ملت' height={24} src='/images/bank/Mellat.svg' width={24} />,
  cardNo: '610433',
  code: 'BKMTIR'
}, {
  name: 'بانک ملت',
  icon: <Image alt='بانک ملت' height={24} src='/images/bank/Mellat.svg' width={24} />,
  cardNo: '991975',
  code: 'BKMTIR'
}, {
  name: 'بانک رفاه',
  icon: <Image alt='بانک رفاه' height={24} src='/images/bank/Refah.svg' width={24} />,
  cardNo: '589463',
  code: 'REFAIR'
}, {
  name: 'بانک توسعه تعاون',
  icon: <Image alt='بانک توسعه تعاون' height={24} src='/images/bank/ToseeTaavon.svg' width={24} />,
  cardNo: '502908',
  code: 'TTBIIR'
}, {
  name: 'بانک توسعه صادرات',
  icon: <Image alt='بانک توسعه صادرات' height={24} src='/images/bank/ToseeSaderat.svg' width={24} />,
  cardNo: '627648',
  code: 'EDBIIR'
}, {
  name: 'بانک توسعه صادرات',
  icon: <Image alt='بانک توسعه صادرات' height={24} src='/images/bank/ToseeSaderat.svg' width={24} />,
  cardNo: '207177',
  code: 'EDBIIR'
}, {
  name: 'بانک تجارت',
  icon: <Image alt='بانک تجارت' height={24} src='/images/bank/Tejarat.svg' width={24} />,
  cardNo: '627353',
  code: 'BTEJIR'
}, {
  name: 'بانک تجارت',
  icon: <Image alt='بانک تجارت' height={24} src='/images/bank/Tejarat.svg' width={24} />,
  cardNo: '585983',
  code: 'BTEJIR'
}, {
  name: 'بانک سینا',
  icon: <Image alt='بانک سینا' height={24} src='/images/bank/Sina.svg' width={24} />,
  cardNo: '639346',
  code: 'SINAIR'
}, {
  name: 'بانک مسکن',
  icon: <Image alt='بانک مسکن' height={24} src='/images/bank/Maskan.svg' width={24} />,
  cardNo: '628023',
  code: 'BKMNIR'
}, {
  name: 'پست بانک ایران',
  icon: <Image alt='پست بانک ایران' height={24} src='/images/bank/PostBank.svg' width={24} />,
  cardNo: '627760',
  code: 'PBIRIR'
}, {
  name: 'بانک صنعت و معدن',
  icon: <Image alt='بانک صنعت و معدن' height={24} src='/images/bank/Sanatvamadan.svg' width={24} />,
  cardNo: '627961',
  code: 'BOIMIR'
}, {
  name: 'بانک پارسیان',
  icon: <Image alt='بانک پارسیان' height={24} src='/images/bank/Parsian.svg' width={24} />,
  cardNo: '622106',
  code: 'BKPAIR'
}, {
  name: 'بانک پاسارگاد',
  icon: <Image alt='بانک پاسارگاد' height={24} src='/images/bank/Pasargad.svg' width={24} />,
  cardNo: '502229',
  code: 'BKBPIR'
}, {
  name: 'بانک پاسارگاد',
  icon: <Image alt='بانک پاسارگاد' height={24} src='/images/bank/Pasargad.svg' width={24} />,
  cardNo: '639347',
  code: 'BKBPIR'
}, {
  name: 'بانک کارآفرین',
  icon: <Image alt='بانک کارآفرین' height={24} src='/images/bank/Karafarin.svg' width={24} />,
  cardNo: '627488',
  code: 'KBIDIR'
}, {
  name: 'بانک سامان',
  icon: <Image alt='بانک سامان' height={24} src='/images/bank/Saman.svg' width={24} />,
  cardNo: '621986',
  code: 'SABCIR'
}, {
  name: 'بانک سرمایه',
  icon: <Image alt='بانک سرمایه' height={24} src='/images/bank/Sarmayeh.svg' width={24} />,
  cardNo: '639607',
  code: 'SRMBIR'
}, {
  name: 'بانک صادرات',
  icon: <Image alt='بانک صادرات' height={24} src='/images/bank/Saderat.svg' width={24} />,
  cardNo: '603769',
  code: 'BSIRIR'
}, {
  name: 'بانک صادرات',
  icon: <Image alt='بانک صادرات' height={24} src='/images/bank/Saderat.svg' width={24} />,
  cardNo: '903769',
  code: 'BSIRIR'
}, {
  name: 'بانک سپه',
  icon: <Image alt='بانک سپه' height={24} src='/images/bank/Sepah.svg' width={24} />,
  cardNo: '589210',
  code: 'SEPBIR'
}, {
  name: 'بانک سپه',
  icon: <Image alt='بانک سپه' height={24} src='/images/bank/Sepah.svg' width={24} />,
  cardNo: '604932',
  code: 'SEPBIR'
}, {
  name: 'بانک کشاورزی',
  icon: <Image alt='بانک کشاورزی' height={24} src='/images/bank/Keshavarzi.svg' width={24} />,
  cardNo: '603770',
  code: 'KESHIR'
}, {
  name: 'بانک انصار',
  icon: <Image alt='بانک انصار' height={24} src='/images/bank/Ansar.svg' width={24} />,
  cardNo: '627381',
  code: 'ANSBIR'
}, {
  name: 'بانک دی',
  icon: <Image alt='بانک دی' height={24} src='/images/bank/Day.svg' width={24} />,
  cardNo: '502938',
  code: 'DAYBIR'
}, {
  name: 'بانک آینده',
  icon: <Image alt='بانک آینده' height={24} src='/images/bank/Ayandeh.svg' width={24} />,
  cardNo: '636214',
  code: 'AYBKIR'
}, {
  name: 'بانک خاورمیانه',
  icon: <Image alt='بانک خاورمیانه' height={24} src='/images/bank/Khavarmiane.svg' width={24} />,
  cardNo: '585947',
  code: 'KHMIIR'
}, {
  name: 'بانک خاورمیانه',
  icon: <Image alt='بانک خاورمیانه' height={24} src='/images/bank/Khavarmiane.svg' width={24} />,
  cardNo: '505809',
  code: 'KHMIIR'
}, {
  name: 'موسسعه مالی اعتباری کوثر',
  icon: <Image alt='موسسعه مالی اعتباری کوثر' height={24} src='/images/bank/Kosar.svg' width={24} />,
  cardNo: '505801',
  code: 'KOSRIR'
}, {
  name: 'بانک مرکزی',
  icon: <Image alt='بانک مرکزی' height={24} src='/images/bank/Markazi.svg' width={24} />,
  cardNo: '636795',
  code: 'BMJIIR'
}, {
  name: 'بانک گردشگری',
  icon: <Image alt='بانک گردشگری' height={24} src='/images/bank/Gardeshgari.svg' width={24} />,
  cardNo: '505416',
  code: 'TOSMIR'
}, {
  name: 'بانک رسالت',
  icon: <Image alt='بانک رسالت' height={24} src='/images/bank/Resalat.svg' width={24} />,
  cardNo: '504172',
  code: 'RESBIR'
}, {
  name: 'بانک حکمت ایرانیان',
  icon: <Image alt='بانک حکمت ایرانیان' height={24} src='/images/bank/Hekmat.svg' width={24} />,
  cardNo: '636949',
  code: 'HEKMIR'
}, {
  name: 'موسسه اعتباری توسعه',
  icon: <Image alt='موسسه اعتباری توسعه' height={24} src='/images/bank/Tosee.svg' width={24} />,
  cardNo: '628157',
  code: 'BTOSIR'
}, {
  name: 'بانک قرض الحسنه مهر ایران',
  icon: <Image alt='بانک قرض الحسنه مهر ایران' height={24} src='/images/bank/Mehr.svg' width={24} />,
  cardNo: '606373',
  code: 'MEHRIR'
}, {
  name: 'بانک ایران زمین',
  icon: <Image alt='بانک ایران زمین' height={24} src='/images/bank/Iranzamin.svg' width={24} />,
  cardNo: '505785',
  code: 'IRZAIR'
}, {
  name: 'بانک قوامین',
  icon: <Image alt='بانک قوامین' height={24} src='/images/bank/Ghavamin.svg' width={24} />,
  cardNo: '639599',
  code: 'GHAVIR'
}, {
  name: 'موسسه اعتباری ملل',
  icon: <Image alt='موسسه اعتباری ملل' height={24} src='/images/bank/Melal.svg' width={24} />,
  cardNo: '606256',
  code: 'MELLIR'
}, {
  name: 'موسسه اعتباری نور',
  icon: <Image alt='موسسه اعتباری نور' height={24} src='/images/bank/Noor.svg' width={24} />,
  cardNo: '507677',
  code: 'MELLIR'
}, {
  name: 'بانک ایران و ونزوئلا',
  icon: <Image alt='بانک ایران و ونزوئلا' height={24} src='/images/bank/IVBB.svg' width={24} />,
  cardNo: '581874',
  code: 'IRZAIR'
}
// TODO: Find an ID for this bank and enter it in the code
// {
//   name: "بانک مهر اقتصاد",
//   icon: MehrEghtesadLogo,
//   cardNo: "639370",
//   code: "",
// },
];